import {
    AirportShuttle,
    CheckCircle,
    DateRange,
    Event,
    EventAvailable,
    FastForward,
    LocationOn,
    RateReview,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

import { VisitState } from '../../types/visit';

export const VisitStateIcon = ({ state, ...rest }: { state: VisitState } & SvgIconProps) => {
    switch (state) {
        case VisitState.UNSCHEDULED:
            return <DateRange {...rest} />;
        case VisitState.SCHEDULED:
            return <Event {...rest} />;
        case VisitState.EN_ROUTE:
            return <AirportShuttle {...rest} />;
        case VisitState.AT_LOCATION:
            return <LocationOn {...rest} />;
        case VisitState.CONFIRMED:
            return <EventAvailable {...rest} />;
        case VisitState.IN_REVIEW:
            return <RateReview {...rest} />;
        case VisitState.ENDED:
            return <CheckCircle {...rest} />;
        default:
            return <FastForward {...rest} />;
    }
};
